import { faArrowRightFromBracket } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { B2Button } from "@hdb/biome-2";
import { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { useLocation, useNavigate } from "react-router-dom";
import Cookies from "universal-cookie";
import axios from "../../core/api/axiosClientCustomAuth";
import { signoutRequest } from "../openid/openid-manager";
import "./idle-modal.scss";

export const IdleModal = ({
  showModal,
  setShowModal,
  content = null,
  type,
}: any) => {
  const navigate = useNavigate();
  const baseURL = process.env.REACT_APP_BASE_URL_CUSTOM_AUTH;
  const location = useLocation();
  const { pathname } = location;

  const [provider, setProvider] = useState("");

  useEffect(() => {
    const provider = localStorage.getItem("customAuthType");

    if (!provider) {
      return;
    }

    if (provider === "AD") {
      setProvider("azure");
    } else {
      setProvider("hdbiam");
    }
  }, []);

  const handleIdleAndSessionModal = async (type: string) => {
    /*     if (type === "idle") {
      let timeUntilExpiry;
      const cookies = new Cookies();
      const token: any = cookies.get("hdb-token");
      const dToken: any = getTokenDcrypted(token);
      if (dToken?.exp) {
        const currentTime = Math.floor(Date.now() / 1000);
        timeUntilExpiry = (dToken?.exp - currentTime) * 1000;
      }

      if (!timeUntilExpiry || timeUntilExpiry < 0) {
        navigate("/login");
        setShowModal(false);
        return;
      }

      const data = localStorage.getItem("customAuthType");
      let provider;

      if (data === "AD") {
        provider = "azure";
      } else {
        provider = "hdbiam";
      }

      if (provider === "azure" || !provider.length) {
        localStorage.setItem("customAuthType", "AD");
        window.location.href = `${baseURL}/login?provider=azure`;
      } else {
        localStorage.setItem("customAuthType", "HDB");
        window.location.href = `${baseURL}/login?provider=hdbiam&islogin=true`;
      }

      let timers: number[] = JSON.parse(localStorage.getItem("timers") || "[]");
      for (const id of timers) {
        clearTimeout(id);
      }

      localStorage.removeItem("timers");
      localStorage.removeItem("signOutFromIdleSession");
    } else {
      await setShowModal(false);
      await setShowModal(false);
    } */

    await setShowModal(false);
    await setShowModal(false);
  };

  return (
    <Modal
      show={showModal}
      centered={true}
      backdropClassName="custom-backdrop"
      backdrop="static"
      keyboard={false}
    >
      <Modal.Header closeButton onHide={() => handleIdleAndSessionModal(type)}>
        <Modal.Title>{content?.title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>{content?.body}</Modal.Body>
      <Modal.Footer>
        <B2Button
          variant="primary"
          onClick={async () => {
            if (type === "idle") {
              await setShowModal(false);
              await setShowModal(false);
              const idleModalRefreshRedirect = localStorage.getItem(
                "idleModalRefreshRedirect"
              );

              if (idleModalRefreshRedirect) {
                localStorage.removeItem("idleModalRefreshRedirect");
              }

              localStorage.setItem("idleModalRefreshRedirect", pathname);
              window.location.reload();
            } else {
              let timeUntilExpiry;
              // const cookies = new Cookies();
              // const token: any = cookies.get("hdb-token");
              // const dToken: any = getTokenDcrypted(token);

              const userInfo = JSON.parse(
                localStorage.getItem("hdbUserInfo") || "{}"
              );

              if (userInfo?.exp) {
                const currentTime = Math.floor(Date.now() / 1000);
                timeUntilExpiry = (userInfo?.exp - currentTime) * 1000;
              }

              if (!timeUntilExpiry || timeUntilExpiry < 0) {
                navigate("/login");
                setShowModal(false);
                return;
              }

              const data = localStorage.getItem("customAuthType");
              let provider;

              if (data === "AD") {
                provider = "azure";
              } else {
                provider = "hdbiam";
              }

              if (provider === "azure" || !provider.length) {
                // const currentUrl = window.location.href;
                localStorage.setItem("postLoginRedirect", location.pathname);

                localStorage.setItem("customAuthType", "AD");
                window.location.href = `${baseURL}/login?provider=azure&islogin=true`;
              } else {
                // const currentUrl = window.location.href;
                localStorage.setItem("postLoginRedirect", location.pathname);

                localStorage.setItem("customAuthType", "HDB");
                window.location.href = `${baseURL}/login?provider=hdbiam&islogin=true`;
              }

              let timers: number[] = JSON.parse(
                localStorage.getItem("timers") || "[]"
              );

              for (const id of timers) {
                clearTimeout(id);
              }

              localStorage.removeItem("timers");
              localStorage.removeItem("signOutFromIdleSession");
            }
          }}
        >
          {type === "idle" ? "OK" : "Re-Login"}
        </B2Button>

        <B2Button
          variant="primary"
          className="logout-button"
          onClick={() => {
            if (provider) {
              axios.get(`/logout?provider=${provider}`).then((response) => {
                const cookies = new Cookies();
                localStorage.clear();
                sessionStorage.removeItem("currentUrl");
                cookies.remove("hdb-token", { path: "/" });
                localStorage.setItem("serverSignedOut", JSON.stringify(true));

                let timers: number[] = JSON.parse(
                  localStorage.getItem("timers") || "[]"
                );

                for (const id of timers) {
                  clearTimeout(id);
                }

                localStorage.removeItem("timers");
                localStorage.removeItem("signOutFromIdleSession");
                window.location.href = `${response.data}`;
              });
            } else {
              signoutRequest();
            }
          }}
        >
          <FontAwesomeIcon icon={faArrowRightFromBracket} className="me-2" />
          Logout{" "}
        </B2Button>
      </Modal.Footer>
    </Modal>
  );
};
